// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Messages":"cn_a bhj_a bhj_w","Messages__hasSeen":"cn_b bhj_p"};